import JSONAPISerializer from '@ember-data/serializer/json-api';

import type ModelRegistry from 'ember-data/types/registries/model';
import { camelize, dasherize, pluralize, singularize } from '@ember-data/request-utils/string';

export default class ApplicationSerializer extends JSONAPISerializer {
  keyForAttribute(key: string) {
    return key;
  }

  keyForRelationship(key: string /*, relationship, method*/) {
    return key;
  }

  payloadKeyFromModelName<K extends keyof ModelRegistry>(modelName: K) {
    return pluralize(camelize(modelName as string));
  }

  modelNameFromPayloadKey(key: string) {
    return dasherize(singularize(key));
  }
}
